"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _FemaGoModal = _interopRequireDefault(require("./modal/FemaGoModal"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var WithModal = function WithModal(props) {
  var title = props.title,
    type = props.type,
    modalText = props.modalText,
    action = props.action,
    handleConfirm = props.handleConfirm,
    open = props.open,
    handleCancel = props.handleCancel,
    children = props.children;
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FemaGoModal.default, {
    title: title,
    type: type,
    open: open,
    confirmAction: function confirmAction(value) {
      return handleConfirm(value);
    },
    buttonText: action || 'Confirm',
    cancelAction: function cancelAction() {
      return handleCancel();
    }
  }, /*#__PURE__*/_react.default.createElement("p", null, modalText)), /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, children));
};
var _default = WithModal;
exports.default = _default;